// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"navigation-arrow"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12 4L20 20L12 17.5L4 20L12 4Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 4L20 20L12 17.5L4 20L12 4Z","strokeWidth":"props.strokeWidth"}}]}]};

const NavigationArrowIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'navigation-arrow',
    ref,
    icon: element,
  },
));

NavigationArrowIcon.displayName = 'NavigationArrowIcon';

export default NavigationArrowIcon;
